import { Skeleton, Stack, Typography } from '@mui/material'

/**
 * Número ejecutivo (KPI). NUEVO — la única pieza tipográfica que la
 * jerarquía actual (h1-h6/body/caption) no cubre bien: cifras tabulares
 * (`fontVariantNumeric`) para que columnas de números alineen, algo que
 * ninguna variante de MUI declara. No es un tamaño de fuente inventado:
 * usa `h3` como base (ya existente) y solo añade la propiedad numérica.
 */
export function MetricValue({
  value,
  label,
  loading,
  size = 'md',
  valueColor,
}: {
  value: string | number | undefined
  label?: string
  loading?: boolean
  size?: 'sm' | 'md' | 'lg'
  /** Fase 7 (sección 9): única extensión aditiva — permite el mismo tinte
   * "requiere atención" (p. ej. documentos sin estado detectado en
   * `TerritorialFooterStrip`) sin que cada pantalla reinvente su propio
   * número tipográfico manual. Opcional, por defecto el color de texto
   * normal — no cambia ningún uso existente. */
  valueColor?: string
}) {
  const variant = size === 'lg' ? 'h2' : size === 'sm' ? 'h4' : 'h3'
  return (
    <Stack spacing={0.25}>
      {loading ? (
        <Skeleton variant="text" width={64} height={size === 'lg' ? 56 : size === 'sm' ? 32 : 44} />
      ) : (
        <Typography variant={variant} sx={{ fontVariantNumeric: 'tabular-nums', lineHeight: 1, color: valueColor }}>
          {value ?? '—'}
        </Typography>
      )}
      {label && (
        <Typography variant="caption" color="text.secondary">
          {label}
        </Typography>
      )}
    </Stack>
  )
}
